import { api } from './client'

/**
 * F-063 (TASK-0317, REQ-258-001): client di `FeatureFlagsController` (`/api/feature-flags`). `me` e'
 * per ogni utente autenticato (mappa chiave -> acceso, gia' valutata dal server per lui); elenco e
 * scritture sono solo Admin. La chiave non cambia dopo la creazione.
 */
export type FeatureFlagMode = 'Spento' | 'SoloAdmin' | 'Selezionati' | 'Tutti'

export const FEATURE_FLAG_MODE_LABELS: Record<FeatureFlagMode, string> = {
  Spento: 'Spento per tutti',
  SoloAdmin: 'Solo amministratori',
  Selezionati: 'Solo utenti o categorie indicati',
  Tutti: 'Acceso per tutti',
}

export interface FeatureFlag {
  id: number
  key: string
  description: string | null
  mode: FeatureFlagMode
  userIds: number[]
  userCategoryIds: number[]
  createdAt: string
  updatedAt: string | null
  updatedBy: number | null
}

export interface FeatureFlagRequest {
  key?: string
  description: string | null
  mode: FeatureFlagMode
  userIds: number[]
  userCategoryIds: number[]
}

export const featureFlagsApi = {
  me: () => api<{ flags: Record<string, boolean> }>('/api/feature-flags/me'),
  list: () => api<{ items: FeatureFlag[] }>('/api/feature-flags'),
  create: (data: FeatureFlagRequest) =>
    api<FeatureFlag>('/api/feature-flags', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: FeatureFlagRequest) =>
    api<FeatureFlag>(`/api/feature-flags/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  remove: (id: number) => api<void>(`/api/feature-flags/${id}`, { method: 'DELETE' }),
}
